import React from 'react';
import { useModalActions } from '../Modals/modalActions';
import Button from '@cube3/cubicle/src/core/atoms/Button/Button';
import { InjectedFormProps } from 'redux-form';
import Drawer from '@material-ui/core/Drawer/Drawer';
import { Surface } from '@cube3/cubicle/src/components/Surface/Surface';
import { makeCSS } from '@cube3/cubicle/src/utils/makeCSS';
import { SizeVariants } from '@cube3/cubicle/src/theme/themes';
import WorkspaceLogo from '../AppBar/WorkspaceLogo';
import { NavContent } from '@cube3/ui/src/Layout/NavContent';
import { useModalContainer } from '@cube3/ui/src/Modal/ModalManagerUI';

/**
 * The mobile navigation that is being displayed with a drawer
 * when the user clicks on the menu menuItem at the mobile quick navigation.
 */

interface Properties extends InjectedFormProps {
  children: React.ReactNode;
}

const useCSS = makeCSS(({ theme }) => {
  return {
    contents: {
      width: 'calc(100vw - 80px)',
      height: '100%'
    },
    surface: {
      height: '100%'
    },
    topbar: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '8px 16px'
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      padding: '8px 10px',
      height: 'calc(100vh - 80px)'
    }
  };
});

const MobileNavigationModal: React.FunctionComponent<Properties> = ({
  children
}) => {
  const classes = useCSS();

  const { closeAllModals } = useModalActions();
  const container = useModalContainer();

  return (
    <>
      <Drawer
        onClose={() => closeAllModals()}
        anchor={'right'}
        open={true}
        SlideProps={{ direction: 'left' }}
        container={container}
      >
        <div className={classes.contents}>
          <Surface
            className={classes.surface}
            background={'base1'}
            cornerRadius="none"
          >
            <div className={classes.topbar}>
              <div onClick={() => closeAllModals()}>
                <WorkspaceLogo />
              </div>
              <Button
                label=""
                size={SizeVariants.lg}
                background="secondary"
                buttonStyle="ghost"
                iconLeft="close"
                onClick={() => closeAllModals()}
              />
            </div>
            <div className={classes.container}>
              <span onClick={() => closeAllModals()}>{children}</span>
              <NavContent
                showStorageIndicator={true}
                showHelp={true}
                showQueue={true}
              />
            </div>
          </Surface>
        </div>
      </Drawer>
    </>
  );
};

export default MobileNavigationModal;
